import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listOptionsMapping'
})
export class ListOptionsMappingPipe implements PipeTransform {

  transform(value: any[], ...args: any[]): any {
    let count = 1;
    let option = '';
    const options: { label: string, value: any }[] = args[0];
    if(!isNullOrEmpty(value)) {
      for (const val of value){
        if (isNullOrEmpty(val) && value.length == 1) {
          return '-';
        } else if (isNullOrEmpty(value) && value.length > 1) {
          continue;
        }
        let oneOption = options.find(x => x.value == val);
        const result = oneOption?.label ?? val;
        if (count == 1){
          option = option + result;
          count++;
        }else {
          option =  option + '\n' + result;
        }
      }
      return option;
    }else {
      return null;
    }
  }
}


